import { useFlag, useProducts } from '@/lib/api';
import { ProductType } from '@/lib/types';

import { Permission, usePermissions } from './usePermissions';

export const TRANSITION_360_FLAG = 'transition_360_EOL2508';

export function useTransition360Flag(): { isEnabled: boolean } {
    const { data } = useFlag(TRANSITION_360_FLAG);

    return { isEnabled: data === true };
}

// canAccess gates the route and the landing, the flag only hides the menu item
export function useTransition360Access(): {
    canAccess: boolean;
    isShownInMenu: boolean;
    isPending: boolean;
    isFetching: boolean;
} {
    const { data: products, isPending, isFetching } = useProducts();
    const { hasPermission } = usePermissions();
    const { isEnabled } = useTransition360Flag();

    const canAccess =
        (products?.includes(ProductType.transition360) ?? false) &&
        hasPermission(Permission.ReadTransition360);

    return {
        canAccess,
        isShownInMenu: canAccess && isEnabled,
        isPending,
        isFetching,
    };
}
